module.exports = __webpack_public_path__ + "cfdc54772519be35c6c2cd036282d91d.svg";